import { Component, Inject } from "@angular/core";
import { SIDE_EFFECT_DATA_TOKEN, SideEffectData } from './models/types';

@Component({
    selector: "side-effect-create-well-gis-data",
    templateUrl: "./side-effect-create-well-gis-data.component.html",
    standalone: false
})
export class SideEffectCreateWellComponent {
    _seConfiguration: any;
    //useCasingPlanForRelevantValues: boolean = false;

    set seConfiguration(value: any) {
        this._seConfiguration = value || {};
        this._seConfiguration.casingPlanContextTarget = this._seConfiguration.casingPlanContextTarget || "";

        this._seConfiguration.requestType = this._seConfiguration.requestType || "NotDefined";

        this._seConfiguration.applicationIdExpression = this._seConfiguration.applicationIdExpression || '';
        this._seConfiguration.apiNumberExpression = this._seConfiguration.apiNumberExpression || '';
        this._seConfiguration.orgIdExpression = this._seConfiguration.orgIdExpression || '';
        this._seConfiguration.wellTypeExpression = this._seConfiguration.wellTypeExpression || '';
        this._seConfiguration.wellTypeDescriptionExpression = this._seConfiguration.wellTypeDescriptionExpression || '';
        this._seConfiguration.wellDispositionExpression = this._seConfiguration.wellDispositionExpression || '';
        this._seConfiguration.wellDispositionLegacyTrackingExpression = this._seConfiguration.wellDispositionLegacyTrackingExpression || '';


        this._seConfiguration.nameExpression = this._seConfiguration.nameExpression || '';
        this._seConfiguration.complianceExpression = this._seConfiguration.complianceExpression || false;
        this._seConfiguration.proposedFormationExpression = this._seConfiguration.proposedFormationExpression || '';
        this._seConfiguration.originalSpudDateExpression = this._seConfiguration.originalSpudDateExpression || '';

        this._seConfiguration.targetLat83Expression = this._seConfiguration.targetLat83Expression || '';
        this._seConfiguration.targetLong83Expression = this._seConfiguration.targetLong83Expression || '';
        this._seConfiguration.firstTakePointLat83Expression = this._seConfiguration.firstTakePointLat83Expression || '';
        this._seConfiguration.firstTakePointLong83Expression = this._seConfiguration.firstTakePointLong83Expression || '';
        this._seConfiguration.lastTakePointLat83Expression = this._seConfiguration.lastTakePointLat83Expression || '';
        this._seConfiguration.lastTakePointLong83Expression = this._seConfiguration.lastTakePointLong83Expression || '';

        this._seConfiguration.numberExpression = this._seConfiguration.numberExpression || '';

        if (this._seConfiguration.useCasingPlanForRelevantValues == undefined || this._seConfiguration.useCasingPlanForRelevantValues == null)
            this._seConfiguration.useCasingPlanForRelevantValues = true;
        //this.useCasingPlanForRelevantValues = this._seConfiguration.useCasingPlanForRelevantValues;

        //These points also exist on casing plan
        this._seConfiguration.wellHeadLat83Expression = this._seConfiguration.wellHeadLat83Expression || '';
        this._seConfiguration.wellHeadLong83Expression = this._seConfiguration.wellHeadLong83Expression || '';
        this._seConfiguration.isPermittedUrbanExpression = this._seConfiguration.isPermittedUrbanExpression || false;
        //The following GIS point attributes are consistent for all a well's points, and can be found on the casing plan we're fetching
        this._seConfiguration.depthExpression = this._seConfiguration.depthExpression || '';
        this._seConfiguration.slantExpression = this._seConfiguration.slantExpression || '';

        this._seConfiguration.isWithoutFiveAcresExpression = this._seConfiguration.isWithoutFiveAcresExpression || false;
        this._seConfiguration.hasReleaseOfLeaseExpression = this._seConfiguration.hasReleaseOfLeaseExpression || false;
        this._seConfiguration.lastTransferPriorToJune2010Expression = this._seConfiguration.lastTransferPriorToJune2010Expression || false;
    }

    get seConfiguration(): any {
        return this._seConfiguration;
    }

    constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) data: SideEffectData) {
        this.seConfiguration = data.configuration;

        //this.useCasingPlanForRelevantValues = this._seConfiguration.useCasingPlanForRelevantValues;
    }
}


